module.exports = __webpack_public_path__ + "static/media/rank-icon.e22c85ea.svg";